import { addScript } from './utils'

/**
 * Insert the OneTrust cookie tracking script
 * @returns void
 */
export const insertCookieTrackingScript = (oneTrustId: string) => {
  if (
    typeof window === 'undefined' ||
    window.location.href?.includes('localhost') ||
    window.cookieTrackingScriptInserted
  ) {
    return
  }

  const isAcceptanceOrTesting =
    window.location.href?.includes('acceptance') ||
    window.location.href?.includes('testing')

  const dataDomainScript = `${oneTrustId}${isAcceptanceOrTesting ? '-test' : ''}`

  addScript(
    `https://cdn.cookielaw.org/consent/${dataDomainScript}/OtAutoBlock.js`,
  )
  addScript('https://cdn.cookielaw.org/scripttemplates/otSDKStub.js', {
    'data-document-language': 'true',
    'data-ot-ignore': 'true',
    'charSet': 'UTF-8',
    'data-domain-script': `${dataDomainScript}`,
  })
  window.OptanonWrapper = () => {}
  window.cookieTrackingScriptInserted = true
}
